import store from '@/state/store'
import { permissionsMap, checkPermission } from '@/utils/utilsPermissions';


export default [
    {
        path: '/welly/openresto',
        name: 'Open Resto',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly/open-resto'),
    },
    {
        path: '/welly/resto',
        name: 'Resto',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly/resto'),
    },
    {
        path: '/welly/newproduct',
        name: 'NewProduct',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly/newproduct'),
    },
    {
        path: '/welly/edit/product/:idDish',
        name: 'EditProduct',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly/editproduct'),
    },
    {
        path: '/welly/my-dishes',
        name: 'My dishes',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/my-dishes/myDishes'),
    },
    {
        path: '/welly/my-dishes/create-dish',
        name: 'Create Dish',
        meta: {
            authRequired: true,
            permissionRequired: permissionsMap.CREATE_OWN_STORE_PRODUCT,
            beforeResolve(routeTo, routeFrom, next) {
                if (checkPermission(permissionsMap.CREATE_OWN_STORE_PRODUCT, store.state.permissions)) {
                    next();
                } else {
                    next(routeFrom.path ? { path: routeFrom.path } : { name: 'default' });
                }
            },
        },
        component: () =>
            import ('./views/my-dishes/createDish'),
    },
    {
        path: '/welly/my-dishes/edit-dish/:id',
        name: 'Edit Dish',
        meta: {
            authRequired: true,
            permissionRequired: permissionsMap.UPDATE_OWN_STORE_PRODUCT,
            beforeResolve(routeTo, routeFrom, next) {
                if (checkPermission(permissionsMap.UPDATE_OWN_STORE_PRODUCT, store.state.permissions)) {
                    next();
                } else {
                    next(routeFrom.path ? { path: routeFrom.path } : { name: 'default' });
                }
            },
        },
        component: () =>
            import ('./views/my-dishes/createDish'),
    },
    {
        path: '/welly/history',
        name: 'History',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly/history'),
    },
    {
        path: '/welly/permission',
        name: 'Permission',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (JSON.parse(localStorage.getItem('user'))?.data?.user?.role.includes('Administrador')) {
                    next();
                } else {
                    next(routeFrom.path ? { path: routeFrom.path } : { name: 'default' });
                }
            },
        },
        component: () =>
            import ('./views/welly/permission'),
    },
    {
        path: '/welly/promos',
        name: 'Promos',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly/promos'),
    },
    {
        path: '/welly/profile',
        name: 'Profile',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly/profile'),
    },
    {
        path: '/welly/newsucursal',
        name: 'NewSucursal',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly/newsucursal'),
    },
    {
        path: '/welly/schedule',
        name: 'Schedule',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly/schedule'),
    },

    {
        path: '/admin/restos',
        name: 'Restos',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly-admin/restos'),
    },
    {
        path: '/admin/newresto',
        name: 'NewResto',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly-admin/newresto'),
    },
    {
        path: '/admin/sucursalestoapprove',
        name: 'SucursalesToApprove',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly-admin/sucursalesToApprove'),
    },
    {
        path: '/admin/configurationriders',
        name: 'ConfigurationRiders',
        meta: {
            authRequired: true,
        },
        component: () =>
            import ('./views/welly-admin/configurationRiders'),
    },

    {
        path: '/',
        name: 'default',
        meta: {
            authRequired: true,
        },
        redirect:() => {
            return { path: '/welly/resto', query: { title: 'Estos son tus wellys del día' } }
          },
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('./views/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () =>
            import ('./views/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () =>
            import ('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                        (route) => route.push('/login')
                    )
                    // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'default' } : {...routeFrom })
            },
        },
    },
    {
        path: '/activate/:email/:token',
        name: 'activate',
        component: () =>
            import ('./views/account/activate'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                    next()
            },
        },
    },
    {
        path: '/404',
        name: '404',
        component: require('./views/utility/404').default,
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: '*',
        redirect: '404',
    },

]